// FeesStructurePDF10.jsx
import React from "react";
import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

// ================= STYLES =================
const styles = StyleSheet.create({
  page: {
    padding: 10,
    fontSize: 7,
    fontFamily: "Helvetica",
  },

  // ===== HEADER =====
  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
  logoContainer: {
    width: "10%",
    alignItems: "flex-start",
  },
  textContainer: {
    width: "90%",
    alignItems: "center",
  },
  logo: {
    width: 38,
    height: 38,
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 600,
    marginTop: 3,
    textAlign: "center",
  },

  // ===== TABLE =====
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 5,
  },
  row: {
    flexDirection: "row",
  },
  thIndex: {
    width: "4%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 1,
    textAlign: "center",
    fontWeight: 600,
    backgroundColor: "#f5f5f5",
    fontSize: 7,
  },
  th: {
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 1,
    textAlign: "center",
    fontWeight: 600,
    backgroundColor: "#f5f5f5",
    fontSize: 7,
    flexWrap: "wrap",
  },
  tdIndex: {
    width: "4%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 1,
    textAlign: "center",
    fontSize: 7,
  },
  td: {
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 1,
    textAlign: "center",
    fontSize: 7,
    flexWrap: "wrap",
  },
});

// ================= COMPONENT =================
const FeesStructurePDF10 = ({ tableData }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={styles.page}>
      {/* ===== HEADER ===== */}
      <View style={styles.header}>
        {/* Logo Left */}
        <View style={styles.logoContainer}>
          <Image src="/assets/images/jac.png" style={styles.logo} />
        </View>

        {/* Title + Subtitle Center */}
        <View style={styles.textContainer}>
          <Text style={styles.title}>JHARKHAND ACADEMIC COUNCIL, RANCHI</Text>
          <Text style={styles.subtitle}>
            Fees Structure of Class X Examination - 2026 (Annual)
          </Text>
        </View>
      </View>

      {/* ===== TABLE ===== */}
      <View style={styles.table}>
        {/* ==== Table Head ==== */}
        <View style={styles.row}>
          <Text style={styles.thIndex}>#</Text>
          <Text style={styles.th}>Appearing</Text>
          {/* <Text style={styles.th}>Attempt</Text> */}
          <Text style={styles.th}>Caste Cate.</Text>
          <Text style={styles.th}>Reg. Yr.</Text>
          <Text style={styles.th}>Candidate Type</Text>
          <Text style={styles.th}>Candidate Cate.</Text>
          <Text style={styles.th}>ODPPM Fee</Text>
          <Text style={styles.th}>Examination Fee</Text>
          <Text style={styles.th}>Local Levy</Text>
          <Text style={styles.th}>Marksheet Fee</Text>
          <Text style={styles.th}>Miscellaneous Fee</Text>
          <Text style={styles.th}>Provisional Mig. Fee</Text>
          <Text style={styles.th}>Re-Reg. Fee</Text>
          <Text style={styles.th}>Total Fees (Before Start of Late Fee)</Text>
          <Text style={styles.th}>Late Fee</Text>
          <Text style={styles.th}>Total Fees (After Start of Late Fee)</Text>
        </View>

        {/* ==== Table Body ==== */}
        {tableData && tableData.length > 0 ? (
          tableData.map((item, index) => (
            <View style={styles.row} key={index}>
              <Text style={styles.tdIndex}>{index + 1}</Text>
              <Text style={styles.td}>{item.appearinG_TYPE || "—"}</Text>
              {/* <Text style={styles.td}>
                                {(item.attempT_TYPE === "GREATER_THAN_0" ? "GREATER-THAN-0" : "") || "—"}
                            </Text> */}

              <Text style={styles.td}>
                {item.castE_CATEGORY === "GENERAL"
                  ? "General & EWS"
                  : item.castE_CATEGORY === "OTHERS"
                  ? "SC/ ST/ BC-1/ BC-2"
                  : ""}
              </Text>
              <Text style={styles.td}>{item.registratioN_YEAR || "—"}</Text>
              <Text style={styles.td}>
                {item.candidatE_TYPE || "—"}{" "}
                {item.attempT_TYPE && (
                  <>
                    {"\n"}
                    <Text>
                     {item.attempT_TYPE === "1"
                          ? "(First Attempt)"
                          : item.attempT_TYPE === "GREATER_THAN_1" ? "(Subsequent Attempt)" : ""}
                        
                    </Text>
                  </>
                )}
              </Text>
              <Text style={styles.td}>{item.candidatE_CATEGORY || "—"}</Text>
              <Text style={styles.td}>{item.odppM_FEE || "0"}</Text>
              <Text style={styles.td}>
                {item.exaM_FEE || "0"}
                {item.appearinG_TYPE === "IMPROVEMENT" && (
                  <>
                    {"\n"}
                    <Text style={{ fontWeight: "bold", color: "red" }}>
                      (Per Subject)
                    </Text>
                  </>
                )}
              </Text>

              <Text style={styles.td}>{item.locaL_LEVY || "0"}</Text>
              <Text style={styles.td}>{item.m_S_FEE_F_C_T || "0"}</Text>
              <Text style={styles.td}>{item.misC_FEE || "0"}</Text>
              <Text style={styles.td}>{item.prO_MIG_FEE || "0"}</Text>
              <Text style={styles.td}>{item.rE_REG_FEE || "0"}</Text>
              <Text style={styles.td}>
                {item.beforE_LATE_TOTAL_FEE || "0"}
                {item.appearinG_TYPE === "IMPROVEMENT" && (
                  <>
                    {"\n"}
                    <Text style={{ fontWeight: "bold", color: "red" }}>
                      (Minimum)
                    </Text>
                  </>
                )}
              </Text>
              <Text style={styles.td}>{item.latE_FEE || "0"}</Text>
              <Text style={styles.td}>
                {item.afteR_LATE_TOTAL_FEE || "0"}
                {item.appearinG_TYPE === "IMPROVEMENT" && (
                  <>
                    {"\n"}
                    <Text style={{ fontWeight: "bold", color: "red" }}>
                      (Minimum)
                    </Text>
                  </>
                )}
              </Text>
            </View>
          ))
        ) : (
          <View style={styles.row}>
            <Text style={{ ...styles.td, width: "100%", textAlign: "center" }}>
              No data available
            </Text>
          </View>
        )}
      </View>
    </Page>
  </Document>
);

export default FeesStructurePDF10;
